import React from "react";

function Page404() {
  return (
    <>
      <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
        <div className="w-full  m-auto bg-white dark:bg-slate-800/60 rounded shadow-lg ring-2 ring-slate-300/50 dark:ring-slate-700/50 lg:max-w-md">
          <div className="text-center p-6 bg-slate-900 rounded-t">
            <a href="index.html">
              <img
                src={require("../img/logow.png")}
                alt="logo"
                className="w-full h-18 mx-auto mb-2"
              />
            </a>
            <h3 className="font-semibold text-white text-xl mb-1">
              Oops! Sorry page does not Exists
            </h3>
          </div>

          <form className="p-6">
            <div className="text-center">
              <img
                src={require("../img/error.png")}
                alt=""
                className="w-32 h-32 block mx-auto my-6"
              />
              <h1 className="font-bold text-7xl dark:text-slate-200">404!</h1>
              <h5 className="font-medium text-lg text-slate-400">
                The Page Does Not Exist
              </h5>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Page404;
